import { render, staticRenderFns } from "./StatusAvatar.vue?vue&type=template&id=052de0ff&scoped=true&"
import script from "./StatusAvatar.vue?vue&type=script&lang=js&"
export * from "./StatusAvatar.vue?vue&type=script&lang=js&"
import style0 from "./StatusAvatar.vue?vue&type=style&index=0&id=052de0ff&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052de0ff",
  null
  
)

export default component.exports